import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logoImage from "../images/logo.png";
import { useAuth } from "./AuthContext";
import "./Auth.css";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { isConfigured, updatePassword } = useAuth();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);

    try {
      await updatePassword(password);
      navigate("/", { replace: true });
    } catch (submitError) {
      setError(submitError.message || "Could not update your password.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <Link className="auth-logo" to="/login">
          <img src={logoImage} alt="BadgeFlow logo" />
        </Link>
        <h1>Update your password</h1>
        <p className="auth-description">Create a new password for your BadgeFlow account</p>

        {error && <div className="auth-alert" role="alert">{error}</div>}

        <form className="auth-form" onSubmit={handleSubmit}>
          <label htmlFor="new-password">New password</label>
          <input
            id="new-password"
            autoComplete="new-password"
            minLength={6}
            onChange={(event) => setPassword(event.target.value)}
            required
            type="password"
            value={password}
          />

          <label htmlFor="confirm-password">Confirm password</label>
          <input
            id="confirm-password"
            autoComplete="new-password"
            minLength={6}
            onChange={(event) => setConfirmPassword(event.target.value)}
            required
            type="password"
            value={confirmPassword}
          />

          <button className="primary auth-submit" disabled={isSubmitting || !isConfigured} type="submit">
            {isSubmitting ? "Updating…" : "Update password"}
          </button>
        </form>
      </section>
    </main>
  );
};

export default ResetPasswordPage;
